import { render, staticRenderFns } from "./AdminModules.vue?vue&type=template&id=3d20ff28&scoped=true"
import script from "./AdminModules.vue?vue&type=script&lang=js"
export * from "./AdminModules.vue?vue&type=script&lang=js"
import style0 from "./AdminModules.vue?vue&type=style&index=0&id=3d20ff28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d20ff28",
  null
  
)

export default component.exports